<template lang="pug">
	el-card
		el-form(:rules="rules",:model="form", ref="form", label-position="left", label-width='200px')
				el-form-item(prop="email_address", label="Email address")
						el-input(v-model="form.email_address")
				el-form-item(v-show="showCompanySelect", prop="company_id",label="Company")
					company-search(v-model="form.company_id", @companiesFromSearch="companiesFromSearch")
				el-form-item(prop="role",label="Role")
					el-select(v-model="form.role_id")
						el-option(v-for="role in Roles", :key="role.id", :label="role.display_name", :value="role.id")
		card-footer
				el-button(type="primary", @click="inviteUser") Invite teammate
</template>

<script>
import gql from "graphql-tag";
import RolesQuery from "@/graphql/queries/Roles";

export default {
	data() {
		return {
			rules: {
				email_address: [
					{ required: true, message: "Please provide an email", trigger: "blur" },
					{ type: "email", message: "Please input correct email address", trigger: ["blur"] }
				],
				company_id: [{ required: true, message: "Please provide a company", trigger: "blur" }],
				role_id: [{ required: true, message: "Please provide a role", trigger: "blur" }]
			},
			form: {
				email_address: null,
				company_id: null,
				role_id: null
			},
			loadingCreateTeammate: false,
			schoolSearch: null,
			showCompanySelect: false
		};
	},

	apollo: {
		Roles: {
			query: RolesQuery,
			fetchPolicy: "cache-and-network"
		}
	},

	methods: {
		companiesFromSearch(companies) {
			if (companies.length > 1) {
				this.showCompanySelect = true;
			}
			return companies;
		},
		async inviteUser() {
			this.loadingCreateTeammate = true;
			try {
				if (this.form.company_id == 'A1329183376') {
					this.$message.error("Failed to invite user, please use Hub to invite Wonde user.");
					return false;
				}

				let valid = await this.$refs.form.validate();

				if (valid) {
					await this.$apollo.mutate({
						mutation: gql`
							mutation InviteUser($input: InviteUserInput!) {
								InviteUser(input: $input) {
									id
								}
							}
						`,
						variables: {
							input: this.form
						}
					});

					this.form = {
						email_address: null,
						role_id: null
					};

					this.$message.success("Saved successfully");
				} else {
					this.$message.error("Failed to invite user, please contact support if problem persists.");
				}
			} catch (error) {
				this.$message.error("Failed to invite user, please contact support if problem persists.");
			}

			this.loadingCreateTeammate = false;
		}
	}
};
</script>
